import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form, Row, Col, Table } from 'react-bootstrap';
import Navbar from '../../../../Shared/AdminNavbar/Navbar';
import baseURL from '../../../../Apiurs/Apiurls';
import { useParams, useNavigate, data } from 'react-router-dom';

const Editproduct = () => {
  debugger
  const [collapsed, setCollapsed] = useState(false);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const productIdToEdit = params.id;
  const [isEditMode, setIsEditMode] = useState(!!productIdToEdit);
  const [productDetails, setProductDetails] = useState({
     detail_id : 0,
    main_category: '',
    sub_category: '',
    product_id: '',
    selected_product: '',
    size: '',
    listprice: '',
    moq: '',
    hsncode: '',
    Quantity: '',
    gstrate: '18',
    description: '',
    batch: '',
    productImage: null,
    techSpecs: null
  });
  const [existingFileNames, setExistingFileNames] = useState({
    productImageName: '',
    techSpecsName: ''
  });
  const [addedProducts, setAddedProducts] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [newMainCategory, setNewMainCategory] = useState('');
  const [newSubCategory, setNewSubCategory] = useState('');
  const [newProduct, setNewProduct] = useState('');

  // Fetch main categories
  useEffect(() => {
    axios.get(`${baseURL}/api/main`)
      .then(response => setMainCategories(response.data))
      .catch(error => console.error("Error fetching main categories", error));
  }, []);

  // Fetch subcategories
  useEffect(() => {
    if (productDetails.main_category) {
      axios.get(`${baseURL}/api/sub-categories-main/${productDetails.main_category}`)
        .then(response => setSubCategories(response.data))
        .catch(error => console.error("Error fetching subcategories", error));
    } else {
      setSubCategories([]);
      setProducts([]);
    }
  }, [productDetails.main_category]);

  // Fetch products
  useEffect(() => {
    if (productDetails.sub_category) {
      axios.get(`${baseURL}/api/products-main/${productDetails.sub_category}`)
        .then(response => setProducts(response.data))
        .catch(error => console.error("Error fetching products", error));
    } else {
      setProducts([]);
    }
  }, [productDetails.sub_category]);

  // Fetch product details for edit mode
  useEffect(() => {
    
    if (!productIdToEdit) return;
    setIsEditMode(true);
    axios.get(`${baseURL}/api/product/${productIdToEdit}`)
      .then(res => {
        const p = res.data;
        console.log("data",res )
        setProductDetails({
             detail_id: p.detail_id ? String(p.detail_id) : '',
          main_category: p.maincategory_id ? String(p.maincategory_id) : '',
          sub_category: p.subcategory_id ? String(p.subcategory_id) : '',
          selected_product: p.product_id ? String(p.product_id) : '',
          size: p.size || '',
          listprice: p.listprice || '',
          moq: p.moq || '',
          hsncode: p.hsncode || '',
          Quantity: p.Quantity || '',
          gstrate: p.gstrate ? String(p.gstrate).replace('%', '') : '18',
          description: p.description || '',
          batch: p.batch || '',
          productImage: null,
          techSpecs: null
        });
        setExistingFileNames({
          productImageName: p.product_image || '',
          techSpecsName: p.tech_specs || ''
        });
      })
      .catch(err => {
        console.error("Error loading product:", err);
        alert("Failed to load product for editing");
      });
  }, [productIdToEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProductDetails(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'main_category' && { sub_category: '', selected_product: '' }),
      ...(name === 'sub_category' && { selected_product: '' })
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setProductDetails(prev => ({ ...prev, [name]: files[0] }));
  };

  const handleCategorySubmit = (e) => {
    e.preventDefault();
    if (!newMainCategory) { alert("Please enter a category name"); return; }
    axios.post(`${baseURL}/api/main-categories-main`, { maincategory_name: newMainCategory })
      .then(() => {
        axios.get(`${baseURL}/api/main`).then(r => setMainCategories(r.data));
        setNewMainCategory('');
        setShowCategoryModal(false);
        alert("Main category added successfully");
      })
      .catch(error => { console.error("Error adding main category", error); alert("Failed to add main category"); });
  };

  const handleSubCategorySubmit = (e) => {
    e.preventDefault();
    if (!newSubCategory) { alert("Please enter a subcategory name"); return; }
    if (!productDetails.main_category) { alert("Please select a main category first"); return; }
    axios.post(`${baseURL}/api/sub-categories-main`, {
      subcategory_name: newSubCategory,
      maincategory_id: productDetails.main_category
    })
      .then(() => {
        axios.get(`${baseURL}/api/sub-categories-main/${productDetails.main_category}`)
          .then(r => setSubCategories(r.data));
        setNewSubCategory('');
        setShowSubCategoryModal(false);
        alert("Subcategory added successfully");
      })
      .catch(error => { console.error("Error adding subcategory", error); alert("Failed to add subcategory"); });
  };

  const handleProductNameSubmit = (e) => {
    e.preventDefault();
    if (!newProduct) { alert("Please enter a product name"); return; }
    if (!productDetails.sub_category) { alert("Please select a subcategory before adding a product"); return; }
    axios.post(`${baseURL}/api/product-name-main`, {
      product_name: newProduct,
      subcategory_id: productDetails.sub_category
    })
      .then(() => {
        axios.get(`${baseURL}/api/products-main/${productDetails.sub_category}`)
          .then(r => setProducts(r.data));
        setNewProduct('');
        setShowProductModal(false);
        alert("Product name added successfully");
      })
      .catch(error => { console.error("Error adding product name", error); alert("Failed to add product name"); });
  };

  const handleAddBatch = () => {
    const requiredFields = ['main_category', 'sub_category', 'selected_product', 'size', 'listprice', 'moq', 'hsncode', 'Quantity', 'gstrate', 'batch'];
    for (const field of requiredFields) {
      if (!productDetails[field]) { alert(`Please fill in the ${field.replace('_', ' ')}`); return; }
    }

    const currentProduct = { ...productDetails };
    const selectedProduct = products.find(p => String(p.product_id) === String(currentProduct.selected_product));
    currentProduct.product_name = selectedProduct ? selectedProduct.product_name : '';

    if (editingIndex !== null) {
      const updatedProducts = [...addedProducts];
      updatedProducts[editingIndex] = currentProduct;
      setAddedProducts(updatedProducts);
      localStorage.setItem('product_batches', JSON.stringify(updatedProducts));
      setEditingIndex(null);
    } else {
      const updatedProducts = [...addedProducts, currentProduct];
      setAddedProducts(updatedProducts);
      localStorage.setItem('product_batches', JSON.stringify(updatedProducts));
    }

    setProductDetails(prev => ({
      ...prev,
      size: '', listprice: '', moq: '', hsncode: '', Quantity: '', gstrate: '18',
      description: '', batch: '', productImage: null, techSpecs: null
    }));
  };

  const handleEditBatch = (index) => {
    setProductDetails(addedProducts[index]);
    console.log('index',index)
    setEditingIndex(index);
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setProductDetails(prev => ({
      ...prev,
      size: '', listprice: '', moq: '', hsncode: '', Quantity: '', gstrate: '18',
      description: '', batch: '', productImage: null, techSpecs: null
    }));
  };

  const handleRemoveBatch = (index) => {
    const updatedList = addedProducts.filter((_, i) => i !== index);
    setAddedProducts(updatedList);
    localStorage.setItem('product_batches', JSON.stringify(updatedList));
    if (editingIndex === index) setEditingIndex(null);
  };


const handleSubmit = async () => {
  if (!productIdToEdit) return;




  const formData = new FormData();
    formData.append('detail_id', productDetails.detail_id);
  formData.append('maincategory_id', productDetails.main_category);
  formData.append('subcategory_id', productDetails.sub_category);
  formData.append('batch', productDetails.batch);
  formData.append('description', productDetails.description || '');
  formData.append('size', productDetails.size);
  formData.append('hsncode', productDetails.hsncode);
  formData.append('gstrate', productDetails.gstrate);
  formData.append('listprice', productDetails.listprice);
  formData.append('moq', productDetails.moq);
  formData.append('Quantity', productDetails.Quantity);

  // Use newly selected file or existing file
  if (productDetails.productImage) {
    formData.append('product_image', productDetails.productImage);
    console.log("productImage added:", productDetails.productImage.name);
  } else if (existingFileNames.productImageName) {
    formData.append('existing_product_image', existingFileNames.productImageName);
    console.log("Using existing product image:", existingFileNames.productImageName);
  } else {
    console.log("No product image selected");
  }

  if (productDetails.techSpecs) {
    formData.append('tech_specs', productDetails.techSpecs);
    console.log("techSpecs added:", productDetails.techSpecs.name);
  } else if (existingFileNames.techSpecsName) {
    formData.append('existing_tech_specs', existingFileNames.techSpecsName);
    console.log("Using existing tech specs:", existingFileNames.techSpecsName);
  } else {
    console.log("No tech specs file selected");
  }

  // Log all FormData entries
  console.log("FormData being sent:");
  for (let pair of formData.entries()) {
    console.log(pair[0] + ": ", pair[1]);
  }

  try {
    const response = await axios.put(`${baseURL}/api/product/${productIdToEdit}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    alert(response.data.message || 'Product updated successfully');
    navigate('/products');
  } catch (err) {
    console.error('Update failed:', err.response?.data || err.message);
    alert(`Failed to update product: ${err.response?.data?.error || err.message}`);
  }
};



  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="card p-4">
          <h3 className="mb-4">{isEditMode ? "Edit Product" : "Add Product"}</h3>
          <Form>
            {/* Category, Subcategory, Product Selection */}
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Select Category</Form.Label>
                  <div className="d-flex">
                    <Form.Control as="select" name="main_category" value={productDetails.main_category} onChange={handleInputChange} required>
                      <option value="">Select Main Category</option>
                      {mainCategories.map(c => <option key={c.maincategory_id} value={c.maincategory_id}>{c.maincategory_name}</option>)}
                    </Form.Control>
                    <Button variant="outline-primary" className="ms-2" onClick={() => setShowCategoryModal(true)}>+</Button>
                  </div>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Sub Category</Form.Label>
                  <div className="d-flex">
                    <Form.Control as="select" name="sub_category" value={productDetails.sub_category} onChange={handleInputChange} required>
                      <option value="">Select Sub Category</option>
                      {subCategories.map(sc => <option key={sc.subcategory_id} value={sc.subcategory_id}>{sc.subcategory_name}</option>)}
                    </Form.Control>
                    <Button variant="outline-primary" className="ms-2" onClick={() => setShowSubCategoryModal(true)}>+</Button>
                  </div>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Product Name</Form.Label>
                  <div className="d-flex">
                    <Form.Control as="select" name="selected_product" value={productDetails.selected_product} onChange={handleInputChange} required>
                      <option value="">Select Product</option>
                      {products.map(p => <option key={p.product_id} value={p.product_id}>{p.product_name}</option>)}
                    </Form.Control>
                    <Button variant="outline-primary" className="ms-2" onClick={() => setShowProductModal(true)}>+</Button>
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Model</Form.Label>
                  <Form.Control type="text" name="batch" value={productDetails.batch} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>List Price</Form.Label>
                  <Form.Control type="number" name="listprice" value={productDetails.listprice} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>HSN Code</Form.Label>
                  <Form.Control type="text" name="hsncode" value={productDetails.hsncode} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>MOQ</Form.Label>
                  <Form.Control type="number" name="moq" value={productDetails.moq} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Quantity</Form.Label>
                  <Form.Control type="number" name="Quantity" value={productDetails.Quantity} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>GST (%)</Form.Label>
                  <Form.Control type="number" name="gstrate" value={productDetails.gstrate} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Size</Form.Label>
                  <Form.Control type="text" name="size" value={productDetails.size} onChange={handleInputChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control type="text" name="description" value={productDetails.description} onChange={handleInputChange} />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Upload Product Image</Form.Label>
                  <Form.Control
                    type="file"
                    name="productImage"
                    onChange={handleFileChange}
                    accept=".jpg,.jpeg,.png,.gif"
                  />
                  <Form.Text className="text-muted">Accepted formats: JPG, JPEG, PNG, GIF</Form.Text>
                  {isEditMode && existingFileNames.productImageName && (
                    <div className="mt-2">
                      Existing image: <a href={`${baseURL}/Uploads/products/${existingFileNames.productImageName}`} target="_blank" rel="noreferrer">{existingFileNames.productImageName}</a>
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Upload Technical Specifications</Form.Label>
                  <Form.Control
                    type="file"
                    name="techSpecs"
                    onChange={handleFileChange}
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                  />
                  <Form.Text className="text-muted">Accepted formats: JPG, JPEG, PNG, PDF, DOC, DOCX</Form.Text>
                  {isEditMode && existingFileNames.techSpecsName && (
                    <div className="mt-2">
                      Existing file: <a href={`${baseURL}/Uploads/products/${existingFileNames.techSpecsName}`} target="_blank" rel="noreferrer">{existingFileNames.techSpecsName}</a>
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex mb-3">
              {isEditMode ? (
                <>
                  <Button variant="outline-primary" className="me-2" onClick={handleSubmit}>Update Product</Button>
                  <Button variant="outline-secondary" onClick={() => navigate('/products')}>Back</Button>
                </>
              ) : (
                <>
                  {editingIndex !== null ? (
                    <>
                      <Button variant="outline-primary" className="me-2" onClick={handleAddBatch}>Update Batch</Button>
                      <Button variant="outline-secondary" onClick={handleCancelEdit}>Cancel</Button>
                    </>
                  ) : (
                    <Button variant="outline-primary" className="me-2" onClick={handleAddBatch}>Add Batch</Button>
                  )}
                </>
              )}
            </div>
            {!isEditMode && (
              <>
                <h5 className="mt-4">Added Products</h5>
                <Table bordered className="mt-2">
                  <thead>
                    <tr>
                      <th>Model</th>
                      <th>Size</th>
                      <th>Quantity</th>
                      <th>MOQ</th>
                      <th>HSN Code</th>
                      <th>GST Rate</th>
                      <th>Price</th>
                      <th>Image</th>
                      <th>Tech Specs</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addedProducts.map((product, index) => (
                      <tr key={index}>
                        <td>{product.batch}</td>
                        <td>{product.size}</td>
                        <td>{product.Quantity}</td>
                        <td>{product.moq}</td>
                        <td>{product.hsncode}</td>
                        <td>{product.gstrate}</td>
                        <td>{product.listprice}</td>
                        <td>{product.productImage ? product.productImage.name : 'No image'}</td>
                        <td>{product.techSpecs ? product.techSpecs.name : 'No file'}</td>
                        <td>
                          <Button variant="info" className="me-2" onClick={() => handleEditBatch(index)}>Edit</Button>
                          <Button variant="danger" onClick={() => handleRemoveBatch(index)}>Remove</Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
            <div className="d-flex justify-content-end mt-3">
              {!isEditMode && (
                <>
                  <Button variant="secondary" className="me-2" onClick={() => navigate('/products')}>Close</Button>
                  <Button variant="primary" onClick={handleSubmit}>Submit All Products</Button>
                </>
              )}
            </div>
          </Form>
        </div>
      </div>
      <Modal show={showCategoryModal} onHide={() => setShowCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Main Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCategorySubmit}>
            <Form.Group controlId="newMainCategory">
              <Form.Label>Category Name</Form.Label>
              <Form.Control type="text" value={newMainCategory} onChange={(e) => setNewMainCategory(e.target.value)} required />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" className="me-2" onClick={() => setShowCategoryModal(false)}>Close</Button>
              <Button variant="primary" type="submit">Submit</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showSubCategoryModal} onHide={() => setShowSubCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Sub Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubCategorySubmit}>
            <Form.Group controlId="newSubCategory">
              <Form.Label>Sub Category Name</Form.Label>
              <Form.Control type="text" value={newSubCategory} onChange={(e) => setNewSubCategory(e.target.value)} required />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" className="me-2" onClick={() => setShowSubCategoryModal(false)}>Close</Button>
              <Button variant="primary" type="submit">Submit</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showProductModal} onHide={() => setShowProductModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleProductNameSubmit}>
            <Form.Group controlId="newProduct">
              <Form.Label>Product Name</Form.Label>
              <Form.Control type="text" value={newProduct} onChange={(e) => setNewProduct(e.target.value)} required />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" className="me-2" onClick={() => setShowProductModal(false)}>Close</Button>
              <Button variant="primary" type="submit">Submit</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Editproduct;